<template>
  <div>
    <p
      class="treatment-link"
      @click="getLink()"
    >
      {{ $t('analysisRequests.labels.treatmentProgram') }}
    </p>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
    name: 'TreatmentProgramSummary',
    props: {
        mutableValue: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            model: { },
        };
    },
    computed: {
        ...mapGetters([
            'userLang',
        ]),
    },
    methods: {
        getLink() {
            const { analysisRequest } = this.mutableValue;
            const { client, site, component } = analysisRequest;
            const redirect = this.$router.resolve({
                name: 'componentTreatmentProgram',
                params: {
                    client,
                    site,
                    componentId: component.id,
                    networkId: component.parentNode,
                },
            });
            window.open(redirect.href, '_blank');
        },
    },
};


</script>
<style lang="scss">
.treatment-link {
    text-decoration: underline;
    cursor: pointer;
}
</style>
